import {
  Box,
  ColorPreset,
  FontWeight,
  P,
  Space,
  Text,
} from "@gocardless/flux-react";
import Image from "next/legacy/image";
import { isValidElement } from "react";

interface ValueProps {
  imagePath?: string;
  headerText?: string;
  content?: React.ReactNode;
}

interface ContentProp {
  content?: React.ReactNode;
}

const Content: React.FC<ContentProp> = ({ content }) =>
  isValidElement(content) ? content : <P>{content}</P>;

const ValueProp: React.FC<ValueProps> = ({
  imagePath,
  headerText,
  content,
}) => (
  <Box>
    {!!imagePath && (
      <Image
        src={imagePath}
        alt="Value Prop"
        width={650}
        height={520}
        quality={100}
      />
    )}
    <Space v={2} />
    <Text size={[null, null, null, 5, 6]} weight={FontWeight.Bold}>
      {headerText}
    </Text>
    <Space v={0.5} />
    <Text size={3} color={ColorPreset.TextOnLight_02}>
      <Content content={content} />
    </Text>
  </Box>
);

export default ValueProp;
